import React from 'react';

import { mergeClasses } from 'classify';
import defaultClasses from './sideNav.module.scss';
import MenuCmp from './menu';
import HintCmp from './hint';
const SideNav = (props) => {
  const classes = mergeClasses(defaultClasses, props.classes);

  return (
    <nav className={classes.root}>
      <div className={classes.sidenav_menu}>
        <div className={classes.nav_accordion}>
          <div className={`${classes.sidenav_menu_heading} tips`}>General</div>
          <MenuCmp classes={classes} />
          <div className={`${classes.sidenav_menu_heading}`}>Tips & Tricks</div>
          <HintCmp classes={classes} />
        </div>
      </div>
    </nav>
  );
};

export default SideNav;
